/**
 * OneDS SDK's environment to set up with
 */ export var OneDSEnvironment = /*#__PURE__*/ function(OneDSEnvironment) {
    OneDSEnvironment["CustomerContent"] = "CUSTOMER_CONTENT";
    OneDSEnvironment["EUDB"] = "EUDB";
    OneDSEnvironment["Public"] = "PUBLIC";
    OneDSEnvironment["DoD"] = "USGOV_DOD";
    OneDSEnvironment["DoJ"] = "USGOV_DOJ";
    return OneDSEnvironment;
}({});
/**
 * Constants about our app used for logging
 */ export var LoggingStrings = /*#__PURE__*/ function(LoggingStrings) {
    /** Product name */ LoggingStrings["ProductName"] = "Microsoft Planner";
    /** Product name for new planner */ LoggingStrings["ProductNameV2"] = "PlannerV2";
    return LoggingStrings;
}({});
